export enum EnumTipoFacturacion {
  Normal = 1,
  Simulacion,
  Regeneracion,
  Refacturacion,
  Conciliacion,
  Anuladora,
  Proforma,
  Complementaria,
  Manual
}
